import { Component, Input, OnInit } from '@angular/core';
declare var Stripe;
import { HttpClient } from "@angular/common/http";
import { environment } from 'src/environments/environment';
import { DeudaService } from 'src/app/services/deuda.service';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-stripe',
  templateUrl: './stripe.page.html',
  styleUrls: ['./stripe.page.scss'],
})
export class StripePage implements OnInit {

  @Input() importeAPagar;
  @Input() datos;
  private importe = null;

  private stripe;
  card: any;
  public spinner = false;
  public status= null;
  public key= null;

  constructor(private http: HttpClient,
              private _deudaService: DeudaService,
              public modalCtrl: ModalController,
    ) {

  }

  async ngOnInit() {
    this.importe = this.importeAPagar;
    this.key = await this._deudaService.getApiKeyStripe();
    this.stripe = Stripe(this.key.apikey)
    this.setupStripe();
  }


  setupStripe() {
    let elements = this.stripe.elements();
    var style = {
      base: {
        color: '#32325d',
        lineHeight: '24px',
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '16px',
        '::placeholder': {
          color: '#aab7c4'
        }
      },
      invalid: {
        color: '#fa755a',
        iconColor: '#fa755a'
      }
    };

    this.card = elements.create('card', { style: style });
    console.log(this.card);
    this.card.mount('#card-element');

    

    this.card.addEventListener('change', event => {
      var displayError = document.getElementById('card-errors');
      if (event.error) {
        displayError.textContent = event.error.message;
      } else {
        displayError.textContent = '';
      }
    });

    

    var form = document.getElementById('payment-form');
    form.addEventListener('submit', event => {
      event.preventDefault();
      console.log(event)

      this.stripe.createSource(this.card).then(result => {
        if (result.error) {
          var errorElement = document.getElementById('card-errors');
          errorElement.textContent = result.error.message;
        } else {
          console.log(result);
          console.log(result.source.id);
          this._deudaService.getPagoStripe(this.importe,result.source.id).then( response =>{
            if(response){
              console.log(response)
              if(response.respuesta == "success"){  
                this.cerrar("SUCCESS");
              }
              if (response.respuesta == "fail") {
                this.cerrar("ERROR");
              }
            }
            if(response == undefined){
              
              this.cerrar("ERROR");
            }
          }, err =>{
            console.log("paso por error")
            this.cerrar("ERROR");

          });
        }
      });
    });
  }

  cerrar(data)
  {
    
    
    this.modalCtrl.dismiss(data);
  }

  cancelarPago(){
    
    this.modalCtrl.dismiss("cancel");

  }

}
